import {
    Box,
    List,
    ListItem,
    ListItemAvatar,
    Typography,
} from '@bb-ui/react-library';
import React from 'react';
import { Avatar } from '@bb-ui/react-library/dist/components/Avatar';
import { User as UserIcon } from '@bb-ui/icons/dist/small/User';
import { Messages } from '@bb-ui/icons/dist/small/Messages';
import { useStyles } from './UserInfoContainer.styles';
import { Role } from '../../../../../contexts/LicenseManagementContext/LicenseManagementContext.types';
import { translateUserRoles } from '../../roles';

interface IUserInfoContainerProps {
    userName: string;
    roles: Role[] | undefined;
}

export const UserInfoContainer: React.FunctionComponent<
    IUserInfoContainerProps
> = ({ userName, roles }) => {
    const classes = useStyles();

    return (
        <div data-testid="user-info-container">
            <List className={classes.list}>
                <ListItem className={classes.listItem}>
                    <ListItemAvatar>
                        <Avatar size="small" alt={userName} />
                    </ListItemAvatar>
                    <Box display="flex" flexDirection="column">
                        <Box
                            display="flex"
                            alignItems="center"
                            className={classes.box}
                        >
                            <Messages />
                            <Typography
                                variant="body1"
                                component="h1"
                                className={classes.userName}
                                data-testid="edit-user-page-heading"
                            >
                                {userName}
                            </Typography>
                        </Box>
                        <Box
                            display="flex"
                            alignItems="center"
                            className={classes.roleBox}
                        >
                            <UserIcon />
                            <Typography
                                variant="body1"
                                className={classes.role}
                            >
                                {translateUserRoles(roles)}
                            </Typography>
                        </Box>
                    </Box>
                </ListItem>
            </List>
        </div>
    );
};
